<template>
	<aside class="filter" id="filter" :class="showfilters ? 'open' : null">
		<div class="filter-header">
			<h2>Filter</h2>
			<a href="javascript:void(0)" class="js-filter-clear filter-clear hide-mobile" v-on:click="clearFilters()">clear all filters</a>
			<i class="icon icon-close filter-close hide-desktop" v-on:click="updateShowFilters"></i>
		</div>
		<div class="filters" id="filters">
			<div class="filter-section">

				<a href="javascript:void(0)" class="js-filter-clear filter-clear hide-desktop" v-on:click="clearFilters()">clear all filters</a>

				<h3>Category</h3>
				<ul class="filters-categories input-group">

					<li class="category" v-for="category in categoryfilters">
						<div class="form-group form checkox-input">
							<input :id="'filter-' + category.ID" type="checkbox" v-model="filters.categories" :value="category.ID" />
							<label :for="'filter-' + category.ID">{{category.Name}}</label>
						</div>
					</li>

				</ul>
			</div>
		</div>
		<div class="filter-actions" :class="filterActionsStuck ? 'static' : ''">
			<button class="btn" v-on:click="applyFilters()">Apply Filters</button>
			<a href="javascript:void(0)" class="js-filter-clear hide-mobile" v-on:click="clearFilters()">Clear Filters</a>
		</div>
	</aside>

</template>


<script>

    export default {
	data: function() {
		return {
			filterActionsStuck: false,
			styleObject: {},
			categoryfilters: [],
			filters: {
				categories: []
			},
		}
		},
	props: {
		showfilters: {
			type: Boolean,
			default: () => {return false}
		},

	},
	watch: {
		showfilters: function (newVal) {
			this.showfilters = newVal;

			let body = document.getElementsByTagName("BODY")[0];

			if (newVal === true) {
				body.classList.add('collapse-shown');
				body.classList.remove('collapse-hide');

				setTimeout(() => {
					$('#filters .js-filter-clear').focus();
				}, 1000);
			}
			else {
				body.classList.add('collapse-hide');
				body.classList.remove('collapse-shown');
			}
		}
	},

	mounted() {
        this.categoryfilters = window.categoryfilters;

        // Get selected categories from session storage
        const filterData = JSON.parse(sessionStorage.getItem('memberPrograms'));

        if (filterData) {
            // Set the filters and apply those changes
            this.filters = filterData;
            this.applyFilters();
        }

		$(window).on('scroll', e => { this.stickFilterActions() });
	},
	methods: {

		stickFilterActions() {
			let $stickyElem = $('.filter-actions');
			let $filters = $('#filters');
			let filterOffset = Math.round($filters.offset().top);
			let filterHeight = $filters.outerHeight();
			let stickyHeight = $stickyElem.outerHeight();
			let viewHeight = $(window).height();
			let totalHeight = filterHeight + (stickyHeight * 2);

			$('.filter + .content-wrapper-main').css('min-height', totalHeight);

			let offset = filterOffset + filterHeight + stickyHeight - $(window).scrollTop();

			if ((offset <= viewHeight) && !this.filterActionsStuck) {
				this.filterActionsStuck = true;
			}
			if ((offset > viewHeight) && this.filterActionsStuck) {
				this.filterActionsStuck = false;
			}
		},
		applyFilters() {

        	// convert for api call
        	let formatFilters = Object.assign({}, this.filters);

        	// encode strings
			formatFilters.categories = formatFilters.categories;

        	this.$emit('setmemberprogramfilters', formatFilters);
			this.updateShowFilters();
        },
		clearFilters() {
			this.filters.categories = [];

			this.$emit('clearfilters');

			this.applyFilters();
		},
		updateShowFilters() {
			this.$emit('updateshowfilters', false);
		},
	}
}

</script>